import { type PivotTableView } from '@/types/schema/views/PivotTableView';
import { usePivotTableQuery } from '@/hooks/api/queries/usePivotTableQuery';
import {
  type PagedViewRecords,
  type ViewRecordsResponse
} from '@/hooks/api/queries/useViewMultipleRecordsQuery';
import { TableSkeleton } from '@/components/views/common/table/TableSkeleton';
import { ViewWithTableContent } from '@/components/views/common/ViewWithTableContent';
import { ViewToolbarSection } from '@/components/views/view-options/ViewToolbarSection';
import { useViewContext } from '@/components/views/ViewContext';
import { ViewHeaderSection } from '@/components/views/ViewHeaderSection';
import { usePivotTableHelpers } from './usePivotTableHelpers';

export function PivotTableViewRender({ sourceData }: { sourceData?: ViewRecordsResponse }) {
  const { view } = useViewContext<PivotTableView>();

  const { generatePivotTableColumns, transformRecords } = usePivotTableHelpers();

  const { data: pivotTableData, isLoading } = usePivotTableQuery({
    viewKey: view.key
  });

  if (isLoading) {
    return <TableSkeleton />;
  }

  const viewWithColumns = {
    ...view,
    columns: pivotTableData ? generatePivotTableColumns(pivotTableData, view) : []
  };

  const pivotTableRecords: PagedViewRecords = pivotTableData
    ? transformRecords(pivotTableData, viewWithColumns)
    : { records: [], totalRecords: 0, totalPages: 1, currentPage: 1, isSearchTermValid: false };

  return (
    <>
      <ViewHeaderSection view={viewWithColumns} className="mb-4" />
      <ViewToolbarSection className="mb-4" />
      <ViewWithTableContent
        pagedViewRecords={pivotTableRecords}
        sourceData={sourceData}
        view={viewWithColumns}
      />
    </>
  );
}
